import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import styles from "./styles.module.scss";
const LabeledInput = (props) => {
    const handleInput = (e) => {
        if (props.max && Number(e.currentTarget.value) > props.max) {
            return;
        }
        props.setValue(e.currentTarget.value.slice(0, props.maxLength));
    };
    return (_jsxs("div", { className: `${styles.input_container} ${props.extraClass}`, children: [_jsx("input", { type: "number", inputMode: "numeric", pattern: "[0-9]*", value: props.value, maxLength: props.maxLength, max: props.max, min: props.min, onInput: handleInput, placeholder: props.placeholder }), _jsx("span", { className: styles.label, children: props.rightLabel })] }));
};
export default memo(LabeledInput);
LabeledInput.defaultProps = {
    maxLength: 0,
    extraClass: "",
    max: 0,
    min: 0,
    placeholder: "",
};
